<template>
  <div>
    <div class="data-section">
      <v-data-table class="data-table" :headers="tableHeaders" :items="logs" :loading-text="loadingText" loader-height="2" :loading="tableLoading" hide-default-footer :mobile-breakpoint="1024" :server-items-length="totalLogs" @update:options="getLogs">
        <template v-slot:item.createDate="{ item }">
          <template v-if="item['createDate']">
            {{ methods.getDateFromIso(item['createDate']) }} {{ methods.getTimeFromIso(item['createDate']) }}
          </template>
          <div v-else class="text-body-2 grey--text">Ingen data...</div>
        </template>
        <template v-slot:item.sendDate="{ item }">
          <template v-if="item['sendDate']">
            {{ methods.getDateFromIso(item['sendDate']) }} {{ methods.getTimeFromIso(item['sendDate']) }}
          </template>
          <div v-else class="text-body-2 grey--text">Ingen data...</div>
        </template>
        <template v-slot:item.status="{ item }">
          <v-tooltip bottom :allow-overflow="true">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" size="22" :class="[logStatusIconColor(item['status'])]">{{ logStatusIconName(item['status']) }}</v-icon>
            </template>
            <span>{{ logStatusText(item['status']) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.messageType="{ item }">
          <span>{{ messageTypeText(item['messageType']) }}</span>
        </template>
        <template v-slot:item.attachment="{ item }">
          <div class="d-flex">
            <EboksAttachment
              v-for="attachment in (item['eboksMessageAttachments'] || [])"
              :key="`eboks-logs-${item['visitId']}-${attachment['type']}-${attachment['id']}`"
              :visit-id="item['visitId']"
              :attachment-id="attachment['id']"
              :attachment-type="attachment['type']"
            />
          </div>
        </template>
      </v-data-table>
    </div>
    <div class="d-flex align-center justify-center">
      <v-pagination color="#e0e6ec" v-model="queryParams.CurrentPage" :length="totalPages" :disabled="tableLoading" :total-visible="7" class="py-4" @input="changeCurrentPage"/>
    </div>
  </div>
</template>

<script>
  import methods from '@/utils/methods';
  import api from '@/api/api';
  import EboksAttachment from '@/components/common/EboksAttachment.vue';
  import logStatusIconMixin from '@/mixins/logStatusIconMixin';

  export default {
    name: 'EboksLogsData',
    components: {EboksAttachment},
    mixins: [logStatusIconMixin],

    data: function () {
      return {
        logs: [],
        loadingText: 'Loading... Please wait',
        totalLogs: 0,
        totalPages: 0,
        queryParams: {
          CurrentPage: 1,
          PageSize: 20,
        },
      };
    },

    computed: {
      methods() {
        return methods;
      },
      tableLoading: function () {
        return this.$store.state.logs.tableLoading;
      },
      filterParams: function () {
        return this.$store.state.logs.filterParams;
      },
      tableHeaders: function () {
        return [
          { text: 'Nr.', value: 'visitId', width: '10%', sortable: false },
          { text: 'Oprette dato', value: 'createDate', width: '20%', sortable: false },
          { text: 'Send dato', value: 'sendDate', width: '20%', sortable: false },
          { text: 'Recipient', value: 'patientCpr', width: '20%', sortable: false },
          { text: 'Status', value: 'status', width: '10%', sortable: false },
          { text: 'Meddelelsestype', value: 'messageType', width: '20%', sortable: false },
          { text: '', value: 'attachment', width: '80px', sortable: false }
        ];
      },
    },

    watch: {
      filterParams: function () {
        this.queryParams.CurrentPage = 1;
        this.getLogs();
      },
    },

    methods: {
      messageTypeText: function (type) {
        let text = {
          0: 'Indkald',
          1: 'Aftalebrev',
          2: 'Xray',
          3: 'Faktura',
          4: 'Tilbud',
          5: 'Vejledning',
          6: 'Kvittering',
          7: 'Rykker',
          8: 'Diverse',
        };
        return text[type];
      },
      changeCurrentPage: function (value) {
        this.queryParams.CurrentPage = value;
        this.getLogs();
      },
      getLogs: async function () {
        try {
          this.$store.commit('logs/updateTableLoading', true);
          let logsData = await api.getEboksLogs({...this.queryParams, ...this.filterParams});
          this.logs = logsData.data['paginationResult'].entities;
          this.totalLogs = logsData.data['paginationResult'].totalEntities;
          this.totalPages = logsData.data['paginationResult'].totalPages;
          this.$store.commit('logs/updateEboksTypeList', logsData.data['eboksMessageTypes']);
          this.$store.commit('logs/updateTableLoading', false);
        } catch (e) {
          this.logs = [];
          this.$store.commit('logs/updateTableLoading', false);
        }
      },
    },
  };
</script>
